export default __webpack_public_path__ + "static/group-creation-two-90edee50d446990e667bc5c0ef215b42.png";